var map = {
	"./DaysOfWeekPicker.vue": "MS06",
	"./Loader.vue": "KVN6",
	"./Modal.vue": "lp6a",
	"./MultiDaysOfWeekPicker.vue": "RoL9",
	"./News.vue": "GX6O",
	"./ObjectMultiSelect.vue": "dZK5",
	"./OverlayLoader.vue": "M6DC",
	"./ScheduleLayout.vue": "Vu32",
	"./Sidebar.vue": "PbAM",
	"./SongCover.vue": "HBYn",
	"./SongsList.vue": "W+4n",
	"./Toggle.vue": "BvLC",
	"./TopMenu.vue": "qVfO"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "sVuv";


//////////////////
// WEBPACK FOOTER
// ./src/components/shared nonrecursive \.vue$
// module id = sVuv
// module chunks = 1